export const normalizeDisapprovalReason = value => {
  const reason = typeof value === "string" ? value.trim() : "";
  return reason || "";
};

export const canSubmitDisapprovalReason = value =>
  !!normalizeDisapprovalReason(value);

export const getDisapprovalTime = topics => {
  if (!Array.isArray(topics)) return 0;

  const disapprovedTopic = topics.find(topic => {
    const longDisapprovedTime =
      Number(
        topic && topic.longDisapprovedTime ? topic.longDisapprovedTime : 0
      ) || 0;
    return longDisapprovedTime > 0;
  });

  return (
    Number(
      disapprovedTopic && disapprovedTopic.longDisapprovedTime
        ? disapprovedTopic.longDisapprovedTime
        : 0
    ) || 0
  );
};

export const applyDisapprovalTime = (topics, disapprovalTime) => {
  const normalizedDisapprovalTime = Number(disapprovalTime || 0) || 0;
  if (!Array.isArray(topics)) return [];
  if (!normalizedDisapprovalTime) return topics;

  return topics.map(topic => {
    const currentDisapprovalTime =
      Number(
        topic && topic.longDisapprovedTime ? topic.longDisapprovedTime : 0
      ) || 0;

    if (currentDisapprovalTime > 0) return topic;

    return {
      ...topic,
      longDisapprovedTime: normalizedDisapprovalTime,
      disapprovedTime:
        (topic && topic.disapprovedTime) || normalizedDisapprovalTime
    };
  });
};
